<template src='./FeatureConfigList.html'></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import CommandCell from "@/components/CommandCellTemplate.vue";
import AuditLog from "@/components/AuditLog.vue";

export default {
  data: function() {
    return {
      // addoredit: false,
      gridData: [],
      skip: 0,
      data: {},
      take: 10,
      pageSize: 10,
      editField: false,
      search: "",
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      name: null,
      type: [
        { name: "General", id: 1 },
        { name: "Addon", id: 2 }
      ],
      defaultItem: {
        name: "--Select--"
      },
      add: true,
      sort: [{ field: "name", dir: "asc" }],
      columns: [
        // { field: "id", title: "ID" },
        { field: "name", title: "Name" },

        { field: "type", title: "Type" },

        { cell: CommandCell, title: "Actions", width: "200px" }
      ],
      dataItems: [],
      currentPage: 1,
      featureId: null,
      auditLogPageSize: 4
    };
  },
  methods: {
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function() {
      this.add = true;
    },
    remove: function(item) {
      return this.$store
        .dispatch("featureConfig/removeFeature", item.dataItem)
        .then(() => {
          //   notify(MESSAGES.CHANGES_SAVE_SUCCESS);
        });
      // .catch(notifyApiError);
    },
    edit: function(item) {
      return this.$store
        .dispatch("featureConfig/editFeature", item.dataItem)
        .then(() => {
          this.$router.push({ name: "Add Feature", params: { add: false } });
        });
    },
    async getDataOnload() {
      this.$store.dispatch("getFeature");
    },
    openForm() {
      this.$router.push({ name: "Add Feature", params: { add: true } });
    },
    async getAuditLogs(dataItem){
      this.currentPage = 1;
      this.featureId = dataItem.dataItem.id;
      await this.$store.dispatch('featureConfig/getAuditLogs', {featureId: this.featureId, pageSize: this.auditLogPageSize, pageNo: this.currentPage})
    },
    async auditPagination(currentPage){
      if(this.currentPage != currentPage){
        this.currentPage = currentPage;
        await this.$store.dispatch('featureConfig/getAuditLogs', {featureId: this.featureId, pageSize: this.auditLogPageSize, pageNo: this.currentPage})
      }
    }
  },
  components: {
    AuditLog
  },
  computed: {
    auditLogs(){ 
      return this.$store.state?.featureConfig?.auditLogs ? this.$store.state.featureConfig.auditLogs : []
    },
    totalAuditLogs(){
      return this.$store.state?.featureConfig?.totalAuditLogs ? this.$store.state.featureConfig.totalAuditLogs : 0;
    },
    featureList() {
      return this.$store.state.features;
    },
    total() {
      if(this.search){
        return this.items ? this.items.length : 0;
      }
      else{
        return this.featureList ? this.featureList.length : 0;
      }
    },
    items: {
      get: function() {
        if(this.search){
            let data = this.featureList.filter(feature => `${feature.name}${feature.type}`.match(new RegExp(this.search, "i")));
            return orderBy(data.slice(this.skip, this.take + this.skip), this.sort);
         }else{
            return orderBy(
              this.featureList.slice(this.skip, this.take + this.skip),
              this.sort
            );
         }
      }
    }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>
